export enum PerfilUsuario {
    ADM = "0",
    MembroTJ = "1",
    PJ = "2",
    PF = "3",
}